<template>
	<div :class="$style.tabs">
		<div
				v-for="{id, name} in tabs"
				:key="id"
				:class="[$style.tabs__item,{[$style.tabs__item_active]: activeTab === id}]"
				@click="change(id)"
		>
			{{ name }}
		</div>
	</div>
</template>

<script>
  export default {
    name: 'Tabs',
    props: {
      tabs: {
        type: Array,
        default: () => {
          return []
        }
      },
      defaultActiveTabId: {
        type: Number,
        default: null
      }
    },
    data () {
      return {
        activeTab: this.defaultActiveTabId
      }
    },
    methods: {
      change (id) {
        this.activeTab = id
        this.$emit('input', id)
      }
    }
  }
</script>

<style lang="scss" module>
	.tabs {
		display: flex;
		&__item {
			border: 1px solid #c4c4c4;
			padding: 0.2rem 0.5rem;
			margin-right: 0.2rem;
			cursor: pointer;
			transition: all 0.5s;
			&_active {
				background-color: lighten(#c4c4c4, 10%);
				border-bottom: none;
				transition: all 0.5s;
			}
			&:hover {
				background-color: lighten(#c4c4c4, 20%);
			}
		}
	}
</style>
